export const dailyRows = []
